import React, { Suspense } from 'react';

const DataWrap: React.FC = ({ children }) => {
  return <Suspense fallback={null}>{children}</Suspense>;
}

export default DataWrap;